export const FRC_CAMERA_QUERY_KEY = 'camera';

export function parseCameraFromHash(hash: string): string | null {
  const match = hash.match(/camera=([^&]+)/);
  return match?.[1] ? decodeURIComponent(match[1]) : null;
}

export function parseCameraFromQuery(
  query: Record<string, unknown>
): string | null {
  const raw = query[FRC_CAMERA_QUERY_KEY];
  if (typeof raw === 'string' && raw.trim()) {
    return decodeURIComponent(raw.trim());
  }
  if (Array.isArray(raw) && typeof raw[0] === 'string' && raw[0].trim()) {
    return decodeURIComponent(raw[0].trim());
  }
  return null;
}

/**
 * Resolves the FRC camera model from the route. Query param `?camera=` is
 * preferred; legacy hash links `#camera=` remain supported.
 */
export function resolveFrcCameraFromRoute(route: {
  query: Record<string, unknown>;
  hash?: string;
}): string | null {
  return (
    parseCameraFromQuery(route.query) ?? parseCameraFromHash(route.hash ?? '')
  );
}

export function appendFrcCameraToHref(
  baseHref: string,
  cameraName: string
): string {
  const trimmedBase = baseHref.trim();
  if (!trimmedBase || !cameraName.trim()) {
    return trimmedBase;
  }

  const hashIndex = trimmedBase.indexOf('#');
  const pathWithQuery =
    hashIndex >= 0 ? trimmedBase.slice(0, hashIndex) : trimmedBase;
  const hash = hashIndex >= 0 ? trimmedBase.slice(hashIndex) : '';
  const queryIndex = pathWithQuery.indexOf('?');
  const pathname =
    queryIndex >= 0 ? pathWithQuery.slice(0, queryIndex) : pathWithQuery;
  const search = queryIndex >= 0 ? pathWithQuery.slice(queryIndex + 1) : '';

  const params = new URLSearchParams(search);
  params.set(FRC_CAMERA_QUERY_KEY, cameraName);

  const nextSearch = params.toString();
  return `${pathname}${nextSearch ? `?${nextSearch}` : ''}${hash}`;
}
